

import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.reducer';
import { getAplicacionesUsuarioPorAmbiente, getAmbienteSelecionado } from '../../redux/usuario/usuario.selectors';
import { Aplicacion } from '../../models/usuario.model';
import { Permiso } from '../../modulos/admin/models/permiso';
import { DatePipe } from '@angular/common';

@Directive({
  selector: '[hasDenied]'
})
export class HasDeniedDirective implements OnInit {
  public _nivel: number;
  public _idApp: number;
  public _viewOpciones: boolean = false;
  public _lock: boolean = true;
  elemntosNivelesPermisos: any;
  date = new Date();
  pipe = new DatePipe('en-US');
  private fechaHoy = this.pipe.transform(this.date, 'yyyy-MM-dd');

  @Input() set hasDenied(value: any) {
    this._nivel = value.nivel;
    this._idApp = value.app;
  }

  constructor(
    private store: Store<AppState>,
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>
  ) { }

  ngOnInit(): void {
    let dataNivelActivo: any = [];
    let renderComponent = false;
    this.store.select(getAmbienteSelecionado).subscribe((response) => {
      this.elemntosNivelesPermisos = response
      
    })

    for (let index = 0; index < this.elemntosNivelesPermisos.length; index++) {
      if (this.elemntosNivelesPermisos[index].idSprNivel == this._nivel && this.elemntosNivelesPermisos[index].idSprAplicacion == this._idApp && this.elemntosNivelesPermisos[index].idSprIndicador == null && this.elemntosNivelesPermisos[index].idSprRiesgo == null) {
        dataNivelActivo = this.elemntosNivelesPermisos[index];
      }  
    }

    if (dataNivelActivo && dataNivelActivo.idSprAplicacion === this._idApp ) {
      if(dataNivelActivo.fechaInicio <=  this.fechaHoy && dataNivelActivo.fechaFin >=  this.fechaHoy ){
    this._viewOpciones = true;
  }else{
   this._viewOpciones = false;
  }
}

    if(this._viewOpciones){
      renderComponent = true;
    }else{
      renderComponent = false;
    }
    if (renderComponent) {
      this.viewContainerRef.createEmbeddedView(this.templateRef)
    } else {
      this.viewContainerRef.clear();
    }
  }
}
